<!--
 * @Descripttion: logisticsOrderList--物流订单表
 * @version: 1
 * @Author: lk
 * @Date: 2019-08-19 17:14:03
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-12 20:57:37
 -->
<template>
  <div v-loading.fullscreen="loading" element-loading-text="加载中">
    <el-tabs v-model="activeName" type="border-card" @tab-click="activeNameChange">
      <el-tab-pane v-for="(item, index) in dictObj.saleOrderType" :key='index' :label="item.dictLabel"
        :name="item.dictValue" v-if="$btnsPermission(item.remark)">
        <template slot="label">
          {{ item.dictLabel }}
          <!-- 异常出库单异常标识1.0版本屏蔽 -->
          <!-- <el-badge v-if="item.name == 'ycwldd' && ycwuNum > 0" class="mark" :value="ycwuNum" /> -->
        </template>
      </el-tab-pane>
      <condition-search :query-items="queryItems" :search-param="searchParam" @search="search" @reset="reset" />
      <el-button v-if="$btnsPermission('outbound:add') && activeName!=='lswldd'" type="primary" @click="handleAdd">创建出库单</el-button>
      <div style="display: flex;margin-top: 12px;">
        <!-- 列表 -->
        <div :style="{ width: isRightShow ? '56%' : '100%' }">
          <el-table ref="dataTable" :height="heightStyleObj" :data="pageListData" highlight-current-row
            :cell-style="cellStyle" border @row-click="openDetails">
            <el-table-column prop="" width="60" label="序号" show-overflow-tooltip>
              <template slot-scope="{ $index }">
                {{ $index + 1 + (searchParam.pageNum - 1) * searchParam.pageSize }}
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="发货日期" width="120px">
              <template slot-scope="scope">
                {{ parseTime(scope.row.specifyDeliveryDate, '{y}-{m}-{d}') }}
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="bizId" width="140px" label="单据编号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="bizType" min-width="120px" label="业务类型" >
              <template slot-scope="scope">
                <dict-tag  :options="dictObj.saleOrderType" :value="scope.row.bizType" />
<!--                <div v-if="scope.row.qtType!==null && scope.row.qtType!==''">
                  <dict-tag  :options="dictObj.bizType" :value="scope.row.qtType" />
                </div>-->
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="applyOrgName" min-width="120px" label="申请部门">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="customer" min-width="120px" label="客户名称"></el-table-column>
<!--            <el-table-column show-overflow-tooltip min-width="120px" label="来源">
              <template slot-scope="scope">
                <span v-if="scope.row.orderSource==='system'">本系统</span>
                <span v-else-if="scope.row.orderSource==='erp'">ERP</span>
              </template>
            </el-table-column>-->
            <el-table-column show-overflow-tooltip min-width="120px" label="出库区域">
              <template slot-scope="scope">
                {{ scope.row | formatterArea }}
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="orderStatus" width="95px" label="订单状态">
              <template slot-scope="scope">
                <dict-tag :options="dictObj.orderStatus" :value="scope.row.orderStatus" />
              </template>
            </el-table-column>
            <el-table-column v-if="activeName == 'ycwldd'" show-overflow-tooltip prop="auditExeMsg" label="异常原因">
            </el-table-column>

          </el-table>
          <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
            :limit.sync="searchParam.pageSize" @pagination="getPageListData" />
        </div>
        <!-- 详情 -->
        <div v-if="isRightShow" class="detail" :style="{ maxHeight: heightStyleObj }">
          <div class="detail-top">
            <div style="font-size: 15px;">
              <div style="margin-bottom: 8px;">{{ crrData.bizId }}</div>
              <dict-tag :options="dictObj.orderStatus" :value="crrData.orderStatus" />
            </div>
            <div>
              <el-button v-if="crrData.orderStatus === 'dcl' && $btnsPermission('outbound:edit')" type="primary" class="common-btn" @click="handleEdit">修改订单
              </el-button>
              <el-button v-if="gbddShow && $btnsPermission('outbound:gb')" type="primary" class="common-btn" @click="hanldClose">关闭订单
              </el-button>
              <el-button v-if="crrData.orderStatus === 'ycl' && $btnsPermission('outbound:exportUdi')" type="primary" class="common-btn" @click="exportUdi">导出UDI
              </el-button>
            </div>
          </div>

          <el-tabs v-model="activeNameForDeatil" type="border-card" @before-leave="detailsTabs"
            @tab-click="handleClickForDeatil">
            <el-tab-pane label="单据信息" name="djxx">
              <infomation v-if="activeNameForDeatil === 'djxx'" ref="myDocumentInformation"
                @changeParentLoading="changeParentLoading">
              </infomation>
            </el-tab-pane>
            <el-tab-pane label="出库产品列表" name="splb">
              <Order-Goods-List v-if="activeNameForDeatil === 'splb'" ref="myOrderGoodsList"
                @changeParentLoading="changeParentLoading">
              </Order-Goods-List>
            </el-tab-pane>
            <!-- <el-tab-pane v-if="crrData.orderStatus != 'dsh' && crrData.used === '出库业务'" label="销售出货单" name="xschd">
              <el-button @click="printInfo(1)">打印预览</el-button>
              <PrintOutInfo ref="PrintOutInfo"></PrintOutInfo>
            </el-tab-pane> -->
            <el-tab-pane label="拣货单" name="jhb">
              <Print-Picking-One v-if="activeNameForDeatil === 'jhb'" ref="myPrintPicking"
                @changeParentLoading="changeParentLoading"></Print-Picking-One>
            </el-tab-pane>
            <el-tab-pane label="验货表" name="yhb">
              <div v-if="crrData.orderStatus === 'dcl' && $btnsPermission('outbound:yh')" style="padding: 10px;">
                <el-switch v-model="crrData.isContinue" active-value="Y" inactive-value="N" active-text="连续验货"
                  inactive-text="重新开始验货" @change="updateLogisOrder">
                </el-switch>
              </div>
              <Check-List
                v-if="activeNameForDeatil === 'yhb'"
                ref="myCheckList"
                :dict-obj="dictObj"
                @changeParentLoading="changeParentLoading"></Check-List>
            </el-tab-pane>
          </el-tabs>
        </div>

        <div class="cell_btn"><a class="zk_btn" @click="handleToggle"><i
              :class="isRightShow ? 'el-icon-caret-right' : 'el-icon-caret-left'"></i></a></div>

      </div>
    </el-tabs>
    <addOrder v-if="addShow" :visible="addShow" :order-info="orderInfo" @close="closeAdd"></addOrder>
  </div>
</template>

<script>
import { regionData } from 'element-china-area-data'
import { findNode } from '@/utils/ruoyi'
import { getDict } from '@/api/common'
import { closeOrder, setContinue, getOrder, getErrorOrderCount,exportAllOrderUdiData } from '@/api/orderManage'
import PrintPickingOne from './components/PrintPickingOne' // 拣货表
import PrintOutInfo from './components/PrintOutInfo' // 销售出货单
import infomation from './components/infomation' // 单据信息
import OrderGoodsList from './components/OrderGoodsList' // 订单商品列表
import CheckList from './components/checkList' // 验货表
import addOrder from './components/addOrder'
export default {
  components: {
    PrintPickingOne,
    PrintOutInfo,
    infomation,
    OrderGoodsList,
    CheckList,
    addOrder
  },
  filters: {
    // 省市区format
    formatterArea(row) {
      const { consigneeProvinceName = '', consigneeCityName = '', consigneeCountyName = '' } = row
      return `${consigneeProvinceName}${consigneeCityName ? `/${consigneeCityName}` : ''}${consigneeCountyName ? `/${consigneeCountyName}` : ''}`
    },
  },
  data() {
    return {

      heightStyleObj: '',
      loading: true, // 遮罩
      isRightShow: true,
      detailsTabs: true,
      addShow: false, // 创建出库单
      activeName: 'ckyw', // 主tabs 默认选中自动待处理物流订单
      activeNameForDeatil: 'splb', // 详情tabs默认选中商品列表
      crrData: {}, // 当前选中的物流订单信息
      orderInfo: {},
      pageListData: [], // 列表数据
      queryItems: [
        {
          label: '关键字',
          field: 'searchValue',
          placeholder: '单据编号/申请部门/客户名称',
          width: '300px',
          type: 'input'
        },
        {
          label: '出库区域',
          field: 'area',
          type: 'cascader',
          options: regionData
        },
        {
          label: '订单状态',
          field: 'orderStatus',
          type: 'select',
          options: []
        },
        {
          label: '业务类型',
          field: 'bizType',
          type: 'select',
          options: []
        }
      ],
      searchParam: { // 查询参数
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      dictObj: {
        orderStatus: [],
        saleOrderType: [],
        bizType:[],
        receiptDeliveryState: [],
      },
    }
  },

  computed: {
    // 发起审核按钮
    auditShow() {
      return this.crrData.orderStatus === 'dsh' && this.searchParam.programType === 'rgcl'
    },
    // 关闭订单按钮
    gbddShow() {
      const orderStatusWhiteList = ['dsh', 'dcl', 'shz','clz']
      const orderStatusExitsFlag = orderStatusWhiteList.includes(this.crrData.orderStatus)
      return (this.activeName === 'qtckyw' && orderStatusExitsFlag) || (this.activeName === 'ckyw' && orderStatusExitsFlag) || this.crrData.orderStatus === 'error' // 自动化订单，或人工处理已审核订单
    }
  },
  created() {
    this.heightStyleObj = window.innerHeight - 405 + 'px'
    // this.getErrorList()
    this.getPageListData()
    this.getDicts(['orderStatus', 'saleOrderType', 'bizType', 'receiptDeliveryState'])
  },
  methods: {
    handleAdd() {
      this.orderInfo = {}
      this.addShow = true
    },
    handleEdit() {
      this.addShow = true
      this.orderInfo = JSON.parse(JSON.stringify(this.crrData))
    },
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
          if (dictType === 'orderStatus') {
            const findIndex = this.queryItems.findIndex(item => item.field === dictType)
            this.queryItems[findIndex].options = JSON.parse(JSON.stringify(res.rows))
          }
          if (dictType === 'saleOrderType') {
            const findIndex = this.queryItems.findIndex(item => item.field === 'bizType')
            this.queryItems[findIndex].options = JSON.parse(JSON.stringify(res.rows))
          }
        })
      })
    },
     // 导出
     exportUdi() {
    
      this.$confirm('当前可导出已验货UDI码数据，点击确认后进行导出', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        exportAllOrderUdiData(this.crrData.orderId).then((res) => {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(res)
          link.download = '已出库UDI码.xlsx'
          link.click()
          this.loading = false
        })
          .catch(() => {
            this.loading = false
          })
        }).catch(() => {});

    },
    // 获取异常订单数据
    getErrorList() {
      let params = {
        newCommonQuery: 'Y',
        allAndOr: 'and',
        pageNum: 1,
        pageSize: 100,
        total: 0,
        orderStatus: 'error',
        isEnd: '' // Y是，N不是
      }
      getErrorOrderCount(params).then(res => {
        this.ycwuNum = res.data.total
      })
    },
    printInfo(key) {
      this.$refs.PrintOutInfo.print2(key, this.crrData.orderId, -1, 1)
    },

    updateLogisOrder(isContinue) {
      // 保存订单信息
      this.loading = true
      const { orderId } = this.crrData
      setContinue({ orderId, isContinue }).then(() => {
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 行颜色
    cellStyle(row) { // 根据报警级别显示颜色
      if (typeof row.row[row.column.label] !== 'undefined' && row.row[row.column.label] !== 'undefined' && row.row[row.column.label] === 'dsh') {
        return 'color: red;'
      }
    },
    // 关闭新增弹窗
    closeAdd() {
      this.addShow = false;
      this.getPageListData()
    },
    //关闭订单
    hanldClose() {
      this.$prompt('请填写关闭订单原因', '关闭订单', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        inputPattern: /^\S{1,666}$/,
        inputErrorMessage: '内容长度不能为空且不能超过666个字符',
        closeOnClickModal: false
      })
        .then(({ value: colseOrderReason }) => {
          this.loading = true // 打开遮罩
          closeOrder({ orderId: this.crrData.orderId, colseOrderReason }).then(() => {
            this.getPageListData() // 重新加载数据列表
          }).finally(() => {
            this.loading = false // 关闭遮罩
          })
        })
        .catch(() => { })
    },
    activeNameChange(data) { // 主tabs切换
      this.searchParam.pageNum = 1
      this.activeName = data.name
      this.getPageListData()

      if(this.activeName==='lswldd'){
        this.queryItems=[
          {
            label: '关键字',
            field: 'searchValue',
            placeholder: '单据编号/申请部门/客户名称',
            width: '300px',
            type: 'input'
          },
          {
            label: '出库区域',
            field: 'area',
            type: 'cascader',
            options: regionData
          },
          {
            label: '业务类型',
            field: 'bizType',
            type: 'select',
            options: this.dictObj.saleOrderType.filter(item => item.dictValue !== 'lswldd')
          }
        ]
      }else{
        this.queryItems=[
          {
            label: '关键字',
            field: 'searchValue',
            placeholder: '单据编号/申请部门/客户名称',
            width: '300px',
            type: 'input'
          },
          {
            label: '出库区域',
            field: 'area',
            type: 'cascader',
            options: regionData
          },
          {
            label: '订单状态',
            field: 'orderStatus',
            type: 'select',
            options: []
          }
        ]
      }
    },
    openDetails(row) {
      this.crrData = row
      this.isRightShow = true
      this.activeNameForDeatil = 'splb' // 将商品列表tab选中
      this.$nextTick(() => {
        this.$refs.myOrderGoodsList.getLogisOrderGoodsLists(this.crrData) // 获取该订单对应商品列表
      })
    },
    // 查询
    search() {
      this.searchParam.pageNum = 1
      this.getPageListData()
    },
    // 重置查询
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.getPageListData()
    },

    // 获取列表数据
    getPageListData() {
      this.loading = true
      const { orderId } = this.crrData
      const params = JSON.parse(JSON.stringify(this.searchParam))
      if (params.area) {
        // 省市区转换
        const [consigneeProvinceName, consigneeCityName, consigneeCountyName] = params.area
        params.consigneeProvinceName = findNode(regionData, consigneeProvinceName) ? findNode(regionData, consigneeProvinceName).label : ''
        params.consigneeCityName = findNode(regionData, consigneeCityName) ? findNode(regionData, consigneeCityName).label : ''
        params.consigneeCountyName = findNode(regionData, consigneeCountyName) ? findNode(regionData, consigneeCountyName).label : ''
        delete params.area
      }
      if (this.activeName === 'lswldd') {
        params.isEnd = 'Y'
      }else {
        params.bizType = this.activeName
      }
      getOrder(params).then(res => {
        this.searchParam.total = res.total
        this.pageListData = res.rows
        this.crrData = this.pageListData.find(item => item.orderId === orderId) ? this.pageListData.find(item => item.orderId === orderId) : this.pageListData[0]
        this.getDicts(['orderStatus'])
        if (this.crrData) {
          this.activeNameForDeatil = 'splb' // 将商品列表tab选中
          this.detailsTabs = true
          this.isRightShow = true
          // 将行设置选中状态
          this.$refs.dataTable.setCurrentRow(this.crrData)
          this.$nextTick(() => {
            this.$refs.myOrderGoodsList.getLogisOrderGoodsLists(this.crrData)
          })
        } else {
          this.isRightShow = false
          this.crrData = {}
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 副tabs 切换
    handleClickForDeatil(data) {
      this.activeNameForDeatil = data.name // 将现在选中的值赋给用于判断的
      this.$nextTick(() => {
        if (this.activeNameForDeatil === 'djxx') {
          this.$refs.myDocumentInformation.getOrderInfo(this.crrData)
        } else if (this.activeNameForDeatil === 'splb') {
          this.$refs.myOrderGoodsList.getLogisOrderGoodsLists(this.crrData)
        } else if (this.activeNameForDeatil === 'jhb') {
          this.$refs.myPrintPicking.getPrintInfo(this.crrData)
        } else if (this.activeNameForDeatil === 'yhb') {
          this.$refs.myCheckList.getInspectionInfoByOrderId(this.crrData)
        }
      })
    },
    // 处理显示与隐藏
    handleToggle() {
      this.isRightShow = !this.isRightShow
      if (this.isRightShow) {
        this.activeNameForDeatil === 'splb'
        this.handleClickForDeatil({ name: 'splb' })
      }

    },
    changeParentLoading(flag) {
      this.loading = flag
    }
  }
}
</script>

<style lang="scss" scoped >
.detail {
  width: 43%;
  margin: 0 12px;
  border: 1px solid #D7D7D7;
  overflow-y: auto;

  /* 让padding-right不会影响内容宽度 */
  .detail-top {
    background-color: rgb(244, 246, 249);
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

/* 定义滚动条样式 */
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

/* 定义滚动条的轨道部分 */
::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}

/* 定义滚动条的thumb部分 */
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
  background: rgba(0, 0, 0, .2);
}
</style>
